













































































































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { Action } from 'vuex-class'
import { mapState } from 'vuex'
import Notice from '@/components/Notice'

@Component({
  components: {
    Notice
  },
  computed: {
    ...mapState({
      userBalance: ({ gamblingContext }: any) => gamblingContext.userBalance.balance,
      currencyCode: ({ gamblingContext }: any) => gamblingContext.currencyCode
    })
  }
})

export default class BettingModal extends Vue {
  @Prop({ type: Array, required: true }) allBets: any
  @Prop({ type: Function, required: true }) deleteBet: any
  @Prop({ type: Function, required: true }) clearBets: any
  @Action('depositAmount') depositAmount: any
  @Action('subtractAmount') subtractAmount: any

  userBalance!: number
  isPlaying: boolean = true
  interval: any =  {}
  playTheBets: boolean = false
  gamesProgess: number = 0
  betAmounts: number[] = [ 200, 500, 1000, 2000, 3000 ]
  cost: number = 200
  errorText: string = ''
  currencyCode!: string

  @Watch('playTheBets')
  onPlayTheBets (val: boolean) {
    if (!val) {
      this.clearBets()
    }
  }

  clearError (): void {
    this.errorText = ''
  }
  playTheBetsMethod () {
    if (this.cost > this.userBalance) {
      this.errorText = `Please deposit, your balance is ${this.currencyCode}${this.userBalance}`
      return
    }
    this.isPlaying = true
    this.playTheBets = true
    this.interval = setInterval(() => {
      if (this.gamesProgess === 100) {
        this.isPlaying = false
        clearInterval(this.interval)
        this.updateAccount()
        return (this.gamesProgess = 0)
      }
      this.gamesProgess += 100
    }, 1000)
  }
  updateAccount () {
    const { cost } = this
    const result = this.betResults.some((bet: any) => bet.type !== bet.betTypeResult)
    return result ? this.subtractAmount(cost) : this.depositAmount(cost * this.totalOdds)
  }
  getResult (odds: string[]) {
    const limitGoals = odds.map((val: any) => {
      if (Number(val) > 9) {
        val = 9.5
      }
      return val
    })
    return `${Math.ceil(Math.random() * Number(limitGoals[2]) * 1.8)} - ${Math.ceil(Math.random() * Number(limitGoals[0]) * 1.8)}`
  }
  getBetTypeResult (result: string) {
    const splitted = result.split('-')
    const homeTeam = Number(splitted[0].trimEnd())
    const awayTeam = Number(splitted[1].trimStart())
    if (homeTeam === awayTeam) {
      return 'X'
    } else if (homeTeam > awayTeam) {
      return '1'
    } else {
      return '2'
    }
  }
  winOrLoss (bet: any) {
    return bet.type === bet.betTypeResult
  }

  get registerBets (): number {
    return this.allBets && this.allBets.length
  }

  get resultText () {
    const result = this.betResults.some((bet: any) => bet.type !== bet.betTypeResult)
    const win = {
      main: 'CONGRATULATIONS! YOU WON!',
      sub: `${this.currencyCode}${Math.ceil(this.cost * this.totalOdds)} has been added to your account! :)`
    }
    const loss = {
      main: 'Sorry, you lost! Better luck next time.',
      sub: `${this.currencyCode}${this.cost} has been withdrawed from your account`
    }
    return result ? loss : win
  }
  get betResults () {
    return this.allBets.map((bet: any) => {
      bet.result = this.getResult(bet.allOdds)
      bet.betTypeResult = this.getBetTypeResult(bet.result)
      return bet
    })
  }
  get totalOdds () {
    return this.allBets.reduce((total: number, val: any) => {
      return total + Number(val.odds)
    }, 0).toFixed(2)
  }
}
